import {useCallback} from 'react';

import {useCommonDataHook} from 'src/hooks/use-common-data-hook';
import {getLicenseNotes} from 'src/openapi/admin/apis/GetLicenseNotesApi';
import {saveLicenseNotes} from 'src/openapi/admin/apis/SaveLicenseNotesApi';
import {useAppDispatch} from 'src/store/hooks';

import type {LicenseNotes} from 'src/openapi/admin/models/LicenseNotes';

type Props = {
    licenseId: number,
};

export const useLicenseNotes = ({licenseId}: Props) => {
    const apiDispatch = useAppDispatch();

    const getDispatchAction = useCallback(() => apiDispatch(
        getLicenseNotes({licenseId}),
    ), [licenseId, apiDispatch]);

    const saveDispatchAction = useCallback((licenseNotes: LicenseNotes) => apiDispatch(
        saveLicenseNotes({licenseId, licenseNotes}),
    ), [licenseId, apiDispatch]);

    return useCommonDataHook({
        getDispatchAction,
        saveDispatchAction,
        initValue: {value: ''},
    });
};
